import { PluginInitializerService } from 'core-client/api'
import { NgsildConnectorService } from './ngsild-connector.service'

export function ngsildConnectorInitializerFactory(
  ngsildConnectorService: NgsildConnectorService,
  configurationService: PluginInitializerService,
): () => Promise<void> {
  return () =>
    new Promise<void>((resolve) => {
      const init = async () => {
        await ngsildConnectorService.setup()
      }

      configurationService.setup('NgsildConnector', init, resolve)
    })
}
